import { environment } from 'src/environments/environment';
import { FEATURE_TOGGLE_DEV, FEATURE_TOGGLE_PROD, FEATURE_TOGGLE_STAGING, FEATURE_TOGGLE_TEST } from '../constants/FeatureToggles';
import { EnvironmentInstance } from '../constants/EnvironmentConst';
import { ENTITY_TYPE } from '../constants/CompanyOrFirm';

export default class FeatureToggleHelper {
  public static championPermissionToggle(
    entityType?: ENTITY_TYPE
  ): FEATURE_TOGGLE_DEV | FEATURE_TOGGLE_TEST | FEATURE_TOGGLE_STAGING | FEATURE_TOGGLE_PROD {
    let selectedToggle: any;
    switch (environment.environmentInstance) {
      case EnvironmentInstance.DEV:
        if (entityType) {
          if (entityType === ENTITY_TYPE.ORGANISATION) {
            selectedToggle = FEATURE_TOGGLE_DEV.ORGANIZATION_CHAMPION_PERMISSION;
          } else if (entityType === ENTITY_TYPE.PROJECT) {
            selectedToggle = FEATURE_TOGGLE_DEV.PROJECT_CHAMPION_PERMISSION;
          } else if (entityType === ENTITY_TYPE.PORTFOLIO) {
            selectedToggle = FEATURE_TOGGLE_DEV.PORTFOLIO_CHAMPION_PERMISSION;
          }
        } else {
          selectedToggle = FEATURE_TOGGLE_DEV.CHAMPION_PERMISSION;
        }
        break;
      case EnvironmentInstance.TEST:
        if (entityType) {
          if (entityType === ENTITY_TYPE.ORGANISATION) {
            selectedToggle = FEATURE_TOGGLE_TEST.ORGANIZATION_CHAMPION_PERMISSION;
          } else if (entityType === ENTITY_TYPE.PROJECT) {
            selectedToggle = FEATURE_TOGGLE_TEST.PROJECT_CHAMPION_PERMISSION;
          } else if (entityType === ENTITY_TYPE.PORTFOLIO) {
            selectedToggle = FEATURE_TOGGLE_TEST.PORTFOLIO_CHAMPION_PERMISSION;
          }
        } else {
          selectedToggle = FEATURE_TOGGLE_TEST.CHAMPION_PERMISSION;
        }
        break;
      case EnvironmentInstance.STAGING:
        if (entityType) {
          if (entityType === ENTITY_TYPE.ORGANISATION) {
            selectedToggle = FEATURE_TOGGLE_STAGING.ORGANIZATION_CHAMPION_PERMISSION;
          } else if (entityType === ENTITY_TYPE.PROJECT) {
            selectedToggle = FEATURE_TOGGLE_STAGING.PROJECT_CHAMPION_PERMISSION;
          } else if (entityType === ENTITY_TYPE.PORTFOLIO) {
            selectedToggle = FEATURE_TOGGLE_STAGING.PORTFOLIO_CHAMPION_PERMISSION;
          }
        } else {
          selectedToggle = FEATURE_TOGGLE_STAGING.CHAMPION_PERMISSION;
        }
        break;
      case EnvironmentInstance.PROD:
        if (entityType) {
          if (entityType === ENTITY_TYPE.ORGANISATION) {
            selectedToggle = FEATURE_TOGGLE_PROD.ORGANIZATION_CHAMPION_PERMISSION;
          } else if (entityType === ENTITY_TYPE.PROJECT) {
            selectedToggle = FEATURE_TOGGLE_PROD.PROJECT_CHAMPION_PERMISSION;
          } else if (entityType === ENTITY_TYPE.PORTFOLIO) {
            selectedToggle = FEATURE_TOGGLE_PROD.PORTFOLIO_CHAMPION_PERMISSION;
          }
        } else {
          selectedToggle = FEATURE_TOGGLE_PROD.CHAMPION_PERMISSION;
        }
        break;
      default:
        break;
    }

    return selectedToggle;
  }

  public static organizationAllowedChampionPermissionToggle():
    | FEATURE_TOGGLE_DEV
    | FEATURE_TOGGLE_TEST
    | FEATURE_TOGGLE_STAGING
    | FEATURE_TOGGLE_PROD {
    if (environment.environmentInstance === EnvironmentInstance.DEV) {
      return FEATURE_TOGGLE_DEV.ORGANIZATION_ALLOWED_CHAMPION_PERMISSION;
    } else if (environment.environmentInstance === EnvironmentInstance.TEST) {
      return FEATURE_TOGGLE_TEST.ORGANIZATION_ALLOWED_CHAMPION_PERMISSION;
    } else if (environment.environmentInstance === EnvironmentInstance.DEMO || environment.environmentInstance === EnvironmentInstance.STAGING) {
      return FEATURE_TOGGLE_STAGING.ORGANIZATION_ALLOWED_CHAMPION_PERMISSION;
    } else {
      return FEATURE_TOGGLE_PROD.ORGANIZATION_ALLOWED_CHAMPION_PERMISSION;
    }
  }

  public static modernizedDesignToggle(): FEATURE_TOGGLE_DEV | FEATURE_TOGGLE_TEST | FEATURE_TOGGLE_STAGING | FEATURE_TOGGLE_PROD {
    switch (environment.environmentInstance) {
      case EnvironmentInstance.DEV:
        return FEATURE_TOGGLE_DEV.MODERNIZED_DESIGN;
      case EnvironmentInstance.TEST:
        return FEATURE_TOGGLE_TEST.MODERNIZED_DESIGN;
      case EnvironmentInstance.STAGING:
      case EnvironmentInstance.DEMO:
        return FEATURE_TOGGLE_STAGING.MODERNIZED_DESIGN;
      default:
        return FEATURE_TOGGLE_PROD.MODERNIZED_DESIGN;
    }
  }
}
